import { render, staticRenderFns } from "./TaxReturnLiquiditySection.vue?vue&type=template&id=5ab47889&scoped=true&"
import script from "./TaxReturnLiquiditySection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnLiquiditySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab47889",
  null
  
)

export default component.exports